export default __webpack_public_path__ + "static/media/17.b83ed5dd.png";